export default function ColorCardsIcon() {
  const card = (x: number, rot: number, fill: string, sym: string, mark: string) => (
    <g transform={`rotate(${rot} 32 56)`}>
      <rect x={x} y="10" width="26" height="38" rx="4" fill={fill} stroke="#fff" strokeWidth="2.5" />
      <text x={x + 13} y="37" textAnchor="middle" fontSize="22" fill="#fff" fillOpacity="0.18">
        {mark}
      </text>
      <rect x={x + 5} y="21" width="16" height="16" rx="5" fill="#fff" />
      <text x={x + 13} y="34" textAnchor="middle" fontSize="11" fontWeight="900" fontFamily="'Trebuchet MS', sans-serif" fill={fill}>
        {sym}
      </text>
    </g>
  );
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      {card(8, -22, '#7a4fd6', '7', '◆')}
      {card(19, 0, '#0fa3a3', '+2', '■')}
      {card(30, 22, '#e8457a', '↺', '●')}
    </svg>
  );
}
